import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=355c31fa"
import script from "./navigator.vue?vue&type=script&lang=js"
export * from "./navigator.vue?vue&type=script&lang=js"
import style0 from "./navigator.vue?vue&type=style&index=0&id=355c31fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports